import PropTypes from 'prop-types';
import { Card, Chip, Stack, Typography } from '@mui/material';
import { keyDetails, sourceText } from './callReviewModel';

export const CARD_SX = { p: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' };

// "Key details": what the summary said (name, treatment, call back, intent) as labelled chips,
// with where it came from. Read-only: the card used to carry a "Use in new lead" button that
// called the same handler as Create lead in the header, which is one action wearing two names.
export default function CallKeyDetails({ extracted }) {
  const details = keyDetails(extracted);
  if (!details.length) return null;
  return (
    <Card sx={CARD_SX} data-testid="call-key-details">
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1.5 }}>
        <Typography variant="subtitle1">Key details</Typography>
        <Chip size="small" variant="outlined" label={sourceText(extracted.source)} />
      </Stack>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {details.map((item) => (
          <Chip
            key={item.key}
            label={
              <span>
                <Typography component="span" variant="caption" color="text.secondary" sx={{ mr: 0.75 }}>
                  {item.label}
                </Typography>
                <Typography component="span" variant="body2" fontWeight={600}>
                  {item.value}
                </Typography>
                {item.note && (
                  <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.75 }}>
                    ({item.note})
                  </Typography>
                )}
              </span>
            }
            variant="soft"
            sx={{ height: 32 }}
          />
        ))}
      </Stack>
    </Card>
  );
}

CallKeyDetails.propTypes = {
  extracted: PropTypes.object,
};
CallKeyDetails.defaultProps = { extracted: null };
